import { Card } from "@/components/ui/card";
import { Repeat, GripVertical, Clock } from "lucide-react";
import { DropModeToggle } from "./QueuePanel";

const hm = (m) => `${Math.floor(m / 60)}h${m % 60 ? ` ${m % 60}m` : ""}`;
const fmt = (d) => (d ? new Date(`${d}T12:00:00Z`).toLocaleDateString("en-GB", { timeZone: "Europe/London", day: "numeric", month: "short" }) : "never");

export default function CommunalPanel({ items, canManage, onDragStart, onDragEnd, dropMode, setDropMode }) {
  return (
    <Card className="p-4 border-slate-200" data-testid="communal-panel">
      <div className="flex items-center gap-2 mb-1">
        <Repeat className="h-4 w-4 text-violet-600" />
        <h3 className="font-semibold text-slate-900 text-sm flex-1">Communal area cleaning <span className="text-violet-700" data-testid="communal-panel-count">({items.length})</span></h3>
      </div>
      <p className="text-[11px] text-slate-400 mb-2">Drag a property onto the calendar to book a communal clean.</p>
      {canManage && <div className="mb-2"><DropModeToggle mode={dropMode} setMode={setDropMode} testid="communal-drop-mode" /></div>}
      {items.length === 0 ? <p className="text-sm text-slate-500" data-testid="communal-panel-empty">No properties on the list.</p> : (
        <div className="space-y-2 max-h-[300px] overflow-y-auto">
          {items.map((p) => (
            <div key={p.id} data-testid={`communal-item-${p.id}`} draggable={canManage} onDragStart={() => onDragStart(p)} onDragEnd={onDragEnd}
              className={`rounded-lg border border-slate-200 bg-white p-2.5 text-xs ${canManage ? "cursor-grab active:cursor-grabbing hover:border-violet-400 hover:shadow-sm" : ""}`}>
              <div className="flex items-start gap-2">
                {canManage && <GripVertical className="h-4 w-4 text-slate-300 shrink-0 mt-0.5" />}
                <div className="min-w-0 flex-1">
                  <p className="font-bold text-slate-800 truncate">{p.address}</p>
                  <p className="text-slate-600 truncate">{p.clientName}</p>
                  <p className="text-slate-500 flex items-center gap-1"><Clock className="h-3 w-3" />{hm(p.communalMinutes || 120)} · last {fmt(p.lastVisit)}{p.nextVisit ? ` · next ${fmt(p.nextVisit)}` : ""}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
